import gql from 'graphql-tag'

export const fetchLink = link_id => {
	return {
		query: gql`
			query ($link_id: bigint!) {
				link: links_by_pk(id: $link_id) {
					name: link_name
					country_id
					url: link_url
					order
					publishing_date
					roles: links_roles {
						id: rol_id
					}
				}
			}
		`,
		variables: {
			link_id
		}
	}
}
